<mat-toolbar color="primary" class="flex flex-row justify-between no-print">

  <div class="text-base">
    <span class="text-xs" *ngIf=" !sessionEventInfo &&  !sessionEventShow &&  !sessionReserveInfo">1.0.0</span>
    <span class="text-xs" *ngIf="!!sessionEventInfo && !!sessionEventInfo.event_name && sessionEventInfo.event_name.length > 0">{{sessionEventInfo.event_name[0].str}}</span>
    <span class="text-xs" *ngIf="!!sessionEventShow && !!sessionEventShow.venue_name && sessionEventShow.venue_name.length > 0">（{{sessionEventShow.venue_name[0].str}}）</span>
    <span class="text-xs" *ngIf="!!sessionReserveInfo">{{'HTML-footer.予約番号：' | translate}}{{sessionReserveInfo.reserve_no}}</span>
  </div>

  <div class="text-base">
    <span class="text-base text-red-400" *ngIf="!!sessionBasicSetting && !!sessionBasicSetting.skip_sbps">{{'HTML-footer.＊＊＊　SBPSスキップ中　＊＊＊＊' | translate}}</span>
  </div>

  <div class="text-xs space-x-2">
    <span *ngIf="!!sessionSysAdmin &&  !sessionLeAdmin &&  !sessionLeUser">{{'HTML-footer.システム管理者：' | translate}}{{sessionSysAdmin.user_name}}</span>
    <span *ngIf=" !sessionSysAdmin && !!sessionLeAdmin &&  !sessionLeUser">{{'HTML-footer.LE管理者：' | translate}}{{sessionLeAdmin.user_name}}</span>
    <span *ngIf=" !sessionSysAdmin &&  !sessionLeAdmin && !!sessionLeUser">{{'HTML-footer.LEユーザー：' | translate}}{{sessionLeUser.user_name}}</span>
    <span *ngIf=" !sessionSysAdmin &&  !sessionLeAdmin &&  !sessionLeUser">COPYRIGHT DENTSU SOKEN INC.</span>
    <span>{{time | date:'HH:mm':'+09:00'}} JPN {{environment}}</span>
  </div>

</mat-toolbar>
